import dayjs from 'dayjs';
import { ISubmissionRequest } from 'app/shared/model/submission-request.model';

export interface IWorkflowDocuments {
  id?: number;
  workflowId?: number | null;
  name?: string | null;
  path?: string | null;
  uploadedAt?: dayjs.Dayjs | null;
  submissionRequest?: ISubmissionRequest | null;
}

export const defaultValue: Readonly<IWorkflowDocuments> = {};
